import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';

import { UIService } from '../../services/ui.service';
import { APIService } from './../../services/api.service';
import { StorageService } from './../../services/storage.service';

@Component({
    selector: 'cs-gincanas',
    templateUrl: './gincanas.component.html',
    styleUrls: ['./gincanas.component.scss']
})
export class GincanasComponent implements OnInit {

    @Input() modal: string = undefined;

    public _columns: string[] = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    public model: any = {
    };

    public gincanas: any[] = [];

    public total: number;
    public dataSource = new MatTableDataSource<any>(this.gincanas);
    public selection = new SelectionModel<any>(true, []);

    public gincanaSelecionada: any;

    constructor(private ui: UIService, private api: APIService, private router: Router, private storage: StorageService) {
    }

    ngOnInit() {

        setTimeout(() => {

            this._columns = [this.modal !== undefined ? 'Selecionado' : 'Acoes', 'Nome'];

            this.paginator.pageSize = this.modal ? 5 : 10;

            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            this.loadSession();
        });
    }

    limparFiltro() {

        this.model = {};
    }

    filtrar(page?: number) {

        this.ui.block('Pesquisando gincanas...');

        const skip: number = (page || this.paginator.pageIndex) * this.paginator.pageSize;

        const parameter: any = JSON.parse(JSON.stringify(this.model));

        parameter.Take = this.paginator.pageSize;
        parameter.Skip = skip;

        if (this.sort && this.sort.direction) {

            parameter.Sort = this.sort.active + '|' + this.sort.direction;
        }
        else {

            parameter.Sort = 'Nome|asc';
        }

        this.api.obterGincanas(parameter).subscribe(

            (response: any) => {

                this.ui.unblock();

                if (response.error) {

                    this.ui.error(response.error);
                }
                else {

                    this.total = response.data.Total;
                    this.gincanas = response.data.Gincanas || [];

                    this.dataSource = new MatTableDataSource<any>(response.data.Gincanas);
                    this.selection = new SelectionModel<any>(true, []);

                    if (page) {

                        this.paginator.pageIndex = page;
                    }
                }

                this.storage.set('session', undefined);
            }
        );
    }

    isAllSelected() {

        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;

        return numSelected === numRows;
    }

    masterToggle() {

        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
    }

    pageChanged(page: any) {

        this.filtrar();
    }

    sortChanged(sort: any) {

        this.filtrar();
    }

    newRecord() {

        this.saveSession();
        this.router.navigate(['/gincanas', 0]);
    }

    editRecord(element: any) {

        this.saveSession();
        this.router.navigate(['/gincanas', element.ID]);
    }

    deleteRecord(element: any) {
    }

    saveSession() {

        this.storage.set('session', {
            model: this.model,
            page: {
                size: this.paginator.pageSize,
                current: this.paginator.pageIndex
            },
            sort: {
                field: this.sort.active,
                direction: this.sort.direction
            }
        });
    }

    loadSession() {

        const session = this.storage.get('session');

        if (session) {

            this.model = session.model;
            this.paginator.pageSize = session.page.size;
            this.sort.active = (session.sort) ? session.sort.field : 'Nome';
            this.sort.direction = (session.sort) ? session.sort.direction : 'asc';

            this.filtrar(session.page.current);
        }
        else {

            this.filtrar();
        }
    }

    selecionaGincana(gincana: any) {

        this.gincanaSelecionada = gincana;
    }

    rowSelected(row: any) {

        if (!this.modal) {

            return;
        }

        if (this.modal === 'single') {

            this.selecionaGincana(row);
        }
        else if (this.modal === 'multiple') {

            this.selection.toggle(row);
        }
    }
}
